import { useIsTreatmentVariantByUser } from "../../utils";

export const useAllowChoseBuiltInProfile = () => {
  const EXPERIMENT_KEY =
    "qfd-1033-allow-certain-users-to-chose-hp-built-in-profiles";

  return useIsTreatmentVariantByUser(EXPERIMENT_KEY);
};
